import React from 'react'
import PropTypes from 'prop-types'
import { SecondaryButton, ErrorMessage, MessageHeader, MessageBody, Columns, Column } from '../../bulma'

/**
* Pagination/infinite scroll button component for the `ProductSearchContainer`
* component. Only displays button if more products can be loaded. Also changes
* to an error message if there arwe any problems getting new products.
*/
function LoadMoreProducts(props) {
  const {
    canLoadMore, fallbackUrl, hasError, isLoading, onClick, ...rest
  } = props

  const loadMoreButton = canLoadMore && !hasError ? (
    <SecondaryButton
      href={fallbackUrl}
      isFullwidth
      isLoading={isLoading}
      onClick={onClick}
    >
      Load More Products
    </SecondaryButton>
  ) : false

  const errorMessage = hasError ? (
    <div>
      <ErrorMessage>
        <MessageHeader>Uh oh!</MessageHeader>
        <MessageBody>
          It looks like there was an error while trying to load the products
          you requested. Try refreshing the page, and if the issue continues,
          contact Customer Support.
        </MessageBody>
      </ErrorMessage>
    </div>
  ) : false

  return (
    <Columns {...rest}>
      <Column size="half" offset="one-quarter">
        {errorMessage}
        {loadMoreButton}
      </Column>
    </Columns>
  )
}

LoadMoreProducts.defaultProps = {
  isLoading: false,
  canLoadMore: true,
  hasError: false,
}

LoadMoreProducts.propTypes = {
  // If the "Load More" button should be displayed.
  canLoadMore: PropTypes.bool,
  // Url for "Load More". In case the onClick needs a fallback.
  fallbackUrl: PropTypes.string,
  // If there was an error retrieving products from the server.
  hasError: PropTypes.bool,
  // If new products are currently being loaded.
  isLoading: PropTypes.bool,
  // Callback for when the "Load More" button is clicked.
  onClick: PropTypes.func.isRequired,
}

export default LoadMoreProducts
